<template>
  <v-container fluid>

<v-layout align-center justify-center row fill-height>

      <v-flex xs12 sm6 md4 lg3>
        <v-card>
          <!-- <v-card-text> -->
          <!-- <img src="@/assets/LOGO_HZD_Digital_curvas.svg" height="80px" class="logo"> -->
          <img src="@/assets/proton.svg" height="80px" class="logo">
          <v-layout row wrap>
            <!-- <v-flex xs12 class="text-xs-center" mt-2>
                <h1>Sign In</h1>
              </v-flex> -->
            <v-flex xs12 mx-4>
              <form @submit.prevent="userSignIn">
                <v-layout column>
                  <v-flex>
                    <v-alert type="error" dismissible v-model="alert">
                      {{ error }}
                    </v-alert>
                  </v-flex>
                  <v-flex>
                    <v-text-field name="email" label="Email" id="email" type="email" v-model="email" required></v-text-field>
                  </v-flex>
                  <v-flex>
                    <!-- autocomplete="new-password" disables auto-completion https://github.com/vuetifyjs/vuetify/issues/2792#issuecomment-408837395-->
                    <v-text-field autocomplete="new-password" name="password" label="Password" id="password" type="password" v-model="password" required></v-text-field>
                  </v-flex>
                  <v-flex class="text-xs-center" mt-3>
                    <v-btn :loading="loading" :disabled="loading" color="primary" type="submit">Entrar</v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-flex>
          </v-layout>
          <!-- </v-card-text> -->
          <v-card-text class="text-xs-right">
            <router-link to="/forgot_password">¿olvido su contraseña?</router-link>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//@TODO: add form validation
export default {
  data() {
    return {
      email: "",
      password: "",
      alert: false
    };
  },
  methods: {
    userSignIn() {
      this.$store.dispatch("userSignIn", {
        email: this.email,
        password: this.password
      });
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  }
};
</script>

<style scoped>
.logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>
